<template>
  <div class="text-center">
    <img alt="Vazio" class="ml-8" src="/assets/no-data.webp" />
    <h4>{{ label }}</h4>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      default: 'Não há dados disponíveis',
    },
  },
};
</script>
